import React from 'react';
import { Box, Typography, LinearProgress } from '@mui/material';

interface Props {
  distribution: Record<number, number>;
  total: number;
}

export const RatingDistributionBars = ({ distribution, total }: Props) => {
  return (
    <>
      <Box sx={{ color: 'text.secondary', pb: 2, width: '100%' }}>
        Based on <Typography sx={{ display: 'inline', fontWeight: 600 }}>{total}</Typography> feedback submissions
      </Box>
      <Box display="flex" flexDirection="column" gap={1}>
        {[5, 4, 3, 2, 1].map((star) => {
          const count = distribution[star] ?? 0;
          const pct = total > 0 ? (count / total) * 100 : 0;

          return (
            <Box key={star} display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" sx={{ width: 16, textAlign: 'right', color: 'text.secondary' }}>
                {star}
              </Typography>
              <Box flex={1}>
                <LinearProgress
                  variant="determinate"
                  value={pct}
                  sx={{
                    height: 8,
                    borderRadius: 5,
                    backgroundColor: 'grey.300',
                    '& .MuiLinearProgress-bar': {
                      borderRadius: 5,
                      backgroundColor: 'warning.main', // star color
                      transition: 'width 0.5s ease',
                    },
                  }}
                />
              </Box>
              <Typography variant="caption" sx={{ width: 32, textAlign: 'right', color: 'text.secondary' }}>
                {count}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </>
  );
};

export default RatingDistributionBars;
